import React from "react";
import { useTranslation } from "react-i18next";

const NoteIcon = ({ notes, userRole, onClick }) => {
  const { t } = useTranslation();

  // Helper function to check if user can see note type
  const canSeeNoteType = (noteType) => {
    if (noteType === "process") {
      return ["partner", "representatives", "admin"].includes(
        userRole?.toLowerCase()
      );
    }
    return true; // Information notes visible to all
  };

  // Get visible notes based on user role
  const visibleNotes = Object.entries(notes).filter(([noteType]) =>
    canSeeNoteType(noteType)
  );

  const hasProcessNote = notes.process && canSeeNoteType("process");
  const hasInfoNote = notes.information && canSeeNoteType("information");
  const noteCount = visibleNotes.length;

  // Determine icon state
  const getIconClass = () => {
    if (hasProcessNote && hasInfoNote) return "both-notes";
    if (hasProcessNote) return "process-only";
    if (hasInfoNote) return "info-only";
    return "no-notes";
  };

  const getIconContent = () => {
    if (noteCount > 1) return noteCount.toString();
    if (hasProcessNote) return "P";
    if (hasInfoNote) return "i";
    return "";
  };

  return (
    <div
      className={`note-icon ${getIconClass()}`}
      onClick={onClick}
      title={t("addNote")}
      tabIndex={0}
      role="button"
      aria-label={`${t("noteIcon")} - ${noteCount} ${t("notes")}`}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(e);
        }
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="note-svg"
      >
        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
      </svg>
      {getIconContent() && (
        <span className="note-badge">{getIconContent()}</span>
      )}
    </div>
  );
};

export default NoteIcon;
